import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule, RadiobuttonModule, SelectModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { ServiceRequestPaymentInputNotificationComponent } from './service-request-payment-input-notification.component';
import { ServiceRequestPaymentInputNotificationSmsComponent } from './service-request-payment-input-notification-sms/service-request-payment-input-notification-sms.component';
import { ServiceRequestPaymentInputNotificationEmailComponent } from './service-request-payment-input-notification-email/service-request-payment-input-notification-email.component';

@NgModule({
  declarations: [
    ServiceRequestPaymentInputNotificationComponent,
    ServiceRequestPaymentInputNotificationSmsComponent,
    ServiceRequestPaymentInputNotificationEmailComponent,
  ],
  exports: [ServiceRequestPaymentInputNotificationComponent],
  imports: [
    CommonModule,
    InputModule,
    SelectModule,
    StaticMsgModule,
    FormsModule,
    ReactiveFormsModule,
    RadiobuttonModule,
  ],
})
export class ServiceRequestPaymentInputNotificationModule {}
